const CN_MOBILE_RE = /^1[3-9]\d{9}$/

/** 去掉 +86 / 86 / 空格 / 连字符后的大陆 11 位号。 */
export function normalizeCnMobile(raw: string): string {
  let s = raw.trim().replace(/[\s-]/g, '')
  if (s.startsWith('+86')) s = s.slice(3)
  else if (s.startsWith('86') && s.length >= 13) s = s.slice(2)
  return s
}

export function isValidCnMobile(raw: string): boolean {
  return CN_MOBILE_RE.test(normalizeCnMobile(raw))
}
